let base;
let domain = window.location.host;
let hotelType = domain.indexOf('localhost') !== -1
switch (domain) {
  case 'crm.xinjingtech.net': // 正式crm
    base = 'https://cdn.xinjngtech.com/'
    // base = 'https://test.cdn.xinjngtech.com/'
    break;
  case 'pre.crm.xinjngtech.com': //  预发布crm      
    base = 'https://cdn.xinjngtech.com/'
    break;
  case 'test.crm.xinjngtech.com': // 测试crm
    base = 'https://test.cdn.xinjngtech.com/'
    break;
  case 'dev.crm.xinjngtech.com': //  开发crm   
    base = 'https://test.cdn.xinjngtech.com/'
    break;
  default:
    if (hotelType) {
      console.log(hotelType, 'url--------')
      base = 'https://test.cdn.xinjngtech.com/'
    } else {
      base = window.location.protocol + '//' + window.location.host.replace('crm', 'cdn') + '/';
    }
    break;

}
export default base;



// WEBPACK FOOTER //
// ./src/api/imgUrl.js